/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Tab_MergeInputs */



/**
* | output |
* | --- |
* | "Combine & Compare" |
*
* @param {Event_Group_Options_Tab_MergeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_tab_merge = /** @type {((inputs?: Event_Group_Options_Tab_MergeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Tab_MergeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Combiner et comparer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kombinieren und vergleichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Combina e confronta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединить и сравнить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Combinar y comparar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并与比较")
	if (locale === "ja") return /** @type {LocalizedString} */ ("組み合わせて比較")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संयोजन और तुलना करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Combine e compare")
	return /** @type {LocalizedString} */ ("Combine & Compare")
});